export enum RemitSettingType {
  DEFAULT = 'DEFAULT',
  SPECIFIC = 'SPECIFIC',
}
